export * from './suggested-shortlist-statistic.interface';
